import BaseComponent from './BaseComponent';

class LoginRegisterModal extends BaseComponent {
  static name() { return 'LoginRegisterModal'; }

  constructor(props, el) {
    super();
    this.props = props;
    this.el = el;
    this.$el = $(el);

    this.objects = {
      $loginForm: this.$el.find('[data-login-form]'),
      $registerCustomerButton: this.$el.find('[data-register-customer]'),
    };

    this.localURL = () => {
      const { $loginForm } = this.objects;
      // Get the current URL including hash
      const url = new URL(window.location.href);
      let searchParams = new URLSearchParams(url.search);
      const time = $loginForm.data('job-time');
      if (time) {
        searchParams.set('job-time', time);
      }

      const date = $loginForm.data('job-date');
      if (date) {
        searchParams.set('job-date', date);
      }
      url.search = searchParams.toString();
      return url;
    };

    this.encodedLocalURL = () => {
      const localURL = this.localURL();
      return encodeURIComponent(localURL.toString());
    };

    this.updateLoginFormDateAction = (e, date) => {
      const { $loginForm } = this.objects;
      $loginForm.data('job-date', date);
      $loginForm.attr('action', `/login/?next=${this.encodedLocalURL()}`);
    };

    this.updateLoginFormTimeAction = (e, time) => {
      const { $loginForm } = this.objects;
      $loginForm.data('job-time', time);
      $loginForm.attr('action', `/login/?next=${this.encodedLocalURL()}`);
    };
  }

  init() {
    console.info('~~~ LoginRegisterModal ~~~');
    const { $loginForm, $registerCustomerButton } = this.objects;
    $registerCustomerButton.on('click', (e) => {
      e.preventDefault();
      window.location.href = `/signup?next=${this.encodedLocalURL()}`;
    });

    $loginForm.attr('action', `/login/?next=${this.encodedLocalURL()}`);

    $(document).on('job-date-picked', this.updateLoginFormDateAction);
    $(document).on('job-time-picked', this.updateLoginFormTimeAction);
  }
}

export default LoginRegisterModal;
